module.exports = __webpack_public_path__ + "static/img/warning.878c886.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/warning.png
// module id = ti/l
// module chunks = 1